<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 col-md-12 col-lg-12">
          <!-- <ng-container *ngIf="!loader">
        <img src="../../../assets/resource/ayurls_loader.gif" alt="loader" class="img-loader">
      </ng-container> -->
          <!-- <h1 class="text-center login-title"><img src="assets/Logo.jpg" ></h1> -->
          <div class="account-wall">
            <ul class="nav nav-tabs">
              <li class="active"><a data-toggle="tab" #signIn id="signIn" href="#login">Login</a></li>
              <li><a data-toggle="tab" #signup href="#signup" id="register">SignUp</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="login" class="tab-pane fade in active">

                <div class="log">
                  <!-- <div class="login-box">
                <h2>LOGIN</h2>
                <p>Sign in with your email and get access.</p>
              </div> -->
                  <!-- <form > -->
                  <!-- <div class="input-cont">
                  <div class="form-group">
                    backend validation 
                    <p class="error-msg">{{message}}</p>

                    <input type="email" placeholder="Email Address" autocomplete="off" class="form-control email-input"
                      name="username" formControlName="email" required>
                  </div>
                   <label>Email Address</label> 
                   <div class="border1"></div> 
                  <div *ngIf="loginForm.get('email').hasError('required') && loginForm.get('email').touched">
                    <small class="error">Email is required</small>
                  </div>
                  <div *ngIf="loginForm.get('email').hasError('email') && loginForm.get('email').touched">
                    <small class="error">Enter valid email</small>
                  </div>
                </div>
                <div class="input-cont">
                  <input type="password" placeholder="Password" autocomplete="off" class="form-control email-input"
                    name="password" formControlName="password" required>
                  
                  <div class="border2"></div>
                  <div *ngIf="loginForm.get('password').hasError('required') && loginForm.get('password').touched">
                    <small class="error">Password is required</small>
                  </div>
                </div>
                <span class="check">
                
                </span>
                <a routerLink ="/forgot-Password">Forgot Password</a>
                <div class="clear"></div> -->
                  <!-- <input class="sign" type="submit"  (click)="keycloak_login()" value="Sign In">
              </form> -->
                  <button type="button" class="sign" (click)="keycloak_login()">Sign In</button>
                  <div class="top">
                    <a routerLink="/forgot-Password">Forgot Password</a>
                    <!-- <a  routerlink="/registration" class="register"  href="/registration">Register Here</a> -->

                  </div>
                  <!-- <span><span>
                  <a href=" http://localhost:8080/auth/realms/ayurls/protocol/openid-connect/auth?client_id=ayurls-local&response_type=code&nonce=nonce&kc_idp_hint=google"
                    class="forSocialLoginBtn">
                    <span><img alt="google" src="assets/googleicon.png" width="30px"></span>
                    <span class="text">Google</span></a></span></span>
              <span>
                <span>
                  <a href="https://www.facebook.com/AyurwayTherapy/" target="_blank" class="forSocialLoginBtn1">
                    <span><img alt="facebook" src="assets/facebook.png" width="30px"></span>
                    <span class="text">Facebook</span></a></span></span> -->
                  
                </div>
              </div>
              <div id="signup" class="tab-pane fade">

                <div class="log">
                  <div class="login-box">
                    <h2>Member</h2>
                    <p>Sign up with your email and get access.</p>
                  </div>
                  <form [formGroup]="registerForm" >
                    <div class="input-cont">
                      <input type="text" placeholder="First Name" class="form-control email-input" name="firstname"
                        formControlName="firstname" required>
                      <div class="border1"></div>
                    </div>
                    <div
                      *ngIf="registerForm.get('firstname').hasError('required') && registerForm.get('firstname').touched">
                      <div class="mandatory">
                        <p>First name cannot be empty</p>
                      </div>
                    </div>
                    <div
                    *ngIf="registerForm.get('firstname').hasError('pattern') && registerForm.get('firstname').touched">
                    <div class="mandatory">
                      <p>First name should be letters</p>
                    </div>
                  </div>
                    <div
                      *ngIf="registerForm.get('firstname').hasError('minlength') && registerForm.get('firstname').touched">
                      <div class="mandatory">
                        <p>Minimum length of first name should be 3 character</p>
                      </div>
                    </div>
                    <div
                      *ngIf="registerForm.get('firstname').hasError('maxlength') && registerForm.get('firstname').touched">
                      <div class="mandatory">
                        <p>Maximum length of first name should be 35 characters</p>
                      </div>
                    </div>
                    <!-- <div class="mandatory" *ngIf="formErrors.firstname">{{formErrors.firstname}}</div> -->
                    <div class="input-cont">
                      <input type="text" placeholder="Last Name" class="form-control email-input" name="lastname"
                        formControlName="lastname" required>
                      <div class="border2"></div>
                    </div>
                    <div
                      *ngIf="registerForm.get('lastname').hasError('required') && registerForm.get('lastname').touched">
                      <div class="mandatory">
                        <p>Last name cannot be empty</p>
                      </div>
                    </div>
                    <div
                    *ngIf="registerForm.get('lastname').hasError('pattern') && registerForm.get('lastname').touched">
                    <div class="mandatory">
                      <p>Last name should be letters</p>
                    </div>
                  </div>
                    <div
                      *ngIf="registerForm.get('lastname').hasError('minlength') && registerForm.get('lastname').touched">
                      <div class="mandatory">
                        <p>Minimum length of last name should be 3 character</p>
                      </div>
                    </div>
                    <div
                      *ngIf="registerForm.get('lastname').hasError('maxlength') && registerForm.get('lastname').touched">
                      <div class="mandatory">
                        <p>Maximum length of last name should be 35 characters</p>
                      </div>
                    </div>
                    <!-- <div class="mandatory" *ngIf="formErrors.lastname">{{formErrors.lastname}}</div> -->
                    <div class="input-cont">
                      <input type="email" placeholder="Email Address" class="form-control email-input" name="email"
                        formControlName="email" autocomplete="new-password"  (keyup)="emailValidation()" required >
                      <div class="border3"></div>
                    </div>
                    <div *ngIf="registerForm.get('email').hasError('required') && registerForm.get('email').touched">
                      <div class="mandatory">
                        <p>Email ID cannot be empty</p>
                      </div>
                    </div>
                    <div *ngIf="registerForm.get('email').hasError('email') && registerForm.get('email').touched">
                      <div class="mandatory">
                        <p>Invalid Email ID</p>
                      </div>
                    </div>
                    <div
                    *ngIf="registerForm.get('email').hasError('exist')&& registerForm.get('email').touched">
                    <div class="mandatory">
                      <p> {{getReq.message|titlecase}} </p>
                    </div>
                  </div>
                    <div class="mandatory" *ngIf="formErrors.email">
                      <p>{{formErrors.email}}</p>
                    </div>
                    <div class="input-cont">
                      <input type="password" placeholder="Password" class="form-control email-input" name="password"
                        formControlName="password" autocomplete="newpassword" required>
                      <div class="border4"></div>
                    </div>
                    <div
                      *ngIf="registerForm.get('password').hasError('required') && registerForm.get('password').touched">
                      <div class="mandatory">
                        <p>Password cannot be empty</p>
                      </div>
                    </div>
                    <div
                      *ngIf="registerForm.get('password').hasError('minlength') && registerForm.get('password').touched">
                      <div class="mandatory">
                        <p>Minimum length of password should be 8 character</p>
                      </div>
                    </div>
                    <div class="mandatory" *ngIf="formErrors.password">
                      <p>{{formErrors.password}}</p>
                    </div>
                    <div class="input-cont">
                      <input type="password" placeholder="Confirm Password" class="form-control email-input"
                        name="confirmPassword" formControlName="confirmPassword" autocomplete="off" required>
                      <div class="border5"></div>
                    </div>
                    <div
                      *ngIf="registerForm.get('confirmPassword').hasError('required') && registerForm.get('confirmPassword').touched">
                      <div class="mandatory">
                        <p>Confirm password cannot be empty</p>
                      </div>
                    </div>
                    <div
                      *ngIf="registerForm.get('confirmPassword').hasError('notSame')&& registerForm.get('confirmPassword').touched">
                      <div class="mandatory">
                        <p> Password cannot be matched </p>
                      </div>
                    </div>
                    <div class="mandatory" *ngIf="formErrors.confirmPassword">
                      <p>{{formErrors.confirmPassword}}</p>
                    </div>
                    <div class="clear"></div>
                    <input type="submit" (click)="sendRegistrationDetails()" value="Register Here">
                  </form>

                  <!-- <span><span>
                      <a href="#"   class="forSocialLoginBtn">
                          <span ><img  alt="google" src="assets/googleicon.png" width="30px"></span>
                          <span>Google</span></a></span></span>
                          <span>
                              <span>
                          <a  href="#" class="forSocialLoginBtn1" >
                              <span><img  alt="facebook" src="assets/facebook.png" width="30px"></span>
                              <span>Facebook</span></a></span></span> -->

                </div>
              </div>


            </div>




          </div>

        </div>
      </div>
    </div><br>

    <ng-template #msg>
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Message</h4>
        <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
            class="bi bi-x-circle"></i></button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <p class="text-center">{{modalService.config.initialState.message}}</p>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
        <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
      </div>

    </ng-template>
  </div>
</div>